'use strict';

var _ = require('lodash');
var toastr = require('toastr');
function ConfigurationMarketClassFareInfluencesDataService($q, fileSaveService, restangular) {
  var DEFAULT_BEGIN_DATE = '2000-01-01';
  var DEFAULT_END_DATE = '2100-12-31';
  var CUSTOM_HEADERS = {
    'Content-Type': 'application/json;charset=UTF-8'
  };
  var uniqKeyFields = ['pos', 'origin', 'destination', 'cabin', 'fareClass', 'startTravelDate', 'endTravelDate', 'startRunDate', 'endRunDate'];
  var deleteBulkService = restangular.service('external').one('mcposAverageFaresOverrides');
  var editService = restangular.service('external').one('mcposAverageFaresOverride').one('save');
  var dataRetrieverService;
  function setRetriever(dataRetriever) {
    dataRetrieverService = dataRetriever;
    return dataRetriever;
  }
  function save(editedRows) {
    var payloads = buildPayloads(editedRows, buildPayload);
    return $q.all(_.map(payloads, function (payload) {
      return editService.customPUT(payload);
    }));
  }
  function remove(rows) {
    var payload = {
      mcposAverageFaresOverrides: buildPayloads(rows, buildRemovePayload)
    };
    return deleteBulkService.customOperation('remove', '', {}, CUSTOM_HEADERS, payload);
  }
  function exportToCsv(data) {
    var fileData = createCsvHeader();
    for (var rowId = 0; rowId < data.length; rowId++) {
      fileData += createCsvRow(data[rowId]);
    }
    fileSaveService.createFile(fileData, 'text/csv', 'ConfigurationMarketClassFareInfluences.csv');
  }
  function buildPayload(row) {
    var override = {
      origin: row.origin,
      destination: row.destination,
      pos: row.pos,
      cabin: row.cabin ? allToAsterisk(row.cabin) : undefined,
      fareClass: row.fareClass ? allToAsterisk(row.fareClass) : undefined,
      fareThresholdOverride: row.fareThresholdOverride,
      startTravelDate: row.startTravelDate ? row.startTravelDate.toISOString() : DEFAULT_BEGIN_DATE,
      endTravelDate: row.endTravelDate ? row.endTravelDate.toISOString() : DEFAULT_END_DATE,
      startRunDate: row.startRunDate ? row.startRunDate.toString() : DEFAULT_BEGIN_DATE,
      endRunDate: row.endRunDate ? row.endRunDate.toString() : DEFAULT_END_DATE
    };
    return {
      override: override,
      uniqKey: buildUniqKey(override, row._old)
    };
  }
  function buildUniqKey(override, old) {
    var uniqKey = {};
    _.forEach(uniqKeyFields, function (field) {
      var oldValue = old[field];
      var keyValue = _.isNil(oldValue) ? override[field] : allToAsterisk(old[field]);
      uniqKey[field] = keyValue;
    });
    return uniqKey;
  }
  function buildRemovePayload(row) {
    return {
      origin: row.origin,
      destination: row.destination,
      pos: row.pos,
      cabin: allToAsterisk(row.cabin),
      fareClass: allToAsterisk(row.fareClass),
      fareThresholdOverride: row.fareThresholdOverride,
      startTravelDate: row.startTravelDate.toISOString(),
      endTravelDate: row.endTravelDate.toISOString(),
      startRunDate: row.startRunDate.toString(),
      endRunDate: row.endRunDate.toString()
    };
  }
  function buildPayloads(rows, builder) {
    return _.reduce(rows, function (result, row) {
      result.push(builder(row));
      return result;
    }, []);
  }
  function allToAsterisk(value) {
    return _.includes(['Select All', 'All'], value) ? '*' : value;
  }
  function createCsvHeader() {
    return formatAsCsvRow(['POS', 'Origin', 'Destination', 'Cabin', 'Class', 'Fare Threshold', 'Travel From Date', 'Travel To Date', 'Run Start Date', 'Run End Date']);
  }
  function createCsvRow(row) {
    return formatAsCsvRow([row.pos, row.origin, row.destination, allToAsterisk(row.cabin), allToAsterisk(row.fareClass), row.fareThresholdOverride, row.startTravelDate ? row.startTravelDate.toISOString() : undefined, row.endTravelDate ? row.endTravelDate.toISOString() : undefined, row.startRunDate ? row.startRunDate.toString() : undefined, row.endRunDate ? row.endRunDate.toString() : undefined]);
  }
  function formatAsCsvRow(stringArayToFormat) {
    return stringArayToFormat.join(',') + '\r\n';
  }
  function validate(editedRows, gridData) {
    for (var i = 0; i < editedRows.length; i++) {
      if (isDuplicate(editedRows[i], gridData)) {
        toastr.error('Duplicate rows identified');
        return false;
      }
    }
    return true;
  }
  function isDuplicate(entry, allRows) {
    var fieldsToCheck = _.pick(entry, uniqKeyFields);
    var rowsIdenticalToModified = _.chain(allRows).transform(function (result, entry) {
      var newEntry = _.pick(entry, uniqKeyFields);
      return result.push(newEntry);
    }).filter(fieldsToCheck).value();
    return rowsIdenticalToModified.length > 1;
  }
  return {
    setRetriever: setRetriever,
    save: save,
    remove: remove,
    exportToCsv: exportToCsv,
    validate: validate
  };
}
ConfigurationMarketClassFareInfluencesDataService.$inject = ['$q', 'FileSaveService', 'Restangular'];
module.exports = ConfigurationMarketClassFareInfluencesDataService;